import { appSettings } from '@/shared/consts/appSettings'
import { getMaskZipCode } from '@/utils/helpers/maskInputHelper'

export class Address {
  street: string
  number: string
  complement: string | null
  neighborhood: string
  city: string
  state: string
  country: string
  zipCode: string

  constructor(
    {
      street,
      number,
      complement,
      neighborhood,
      city,
      state,
      country,
      zipCode
    } = {} as any
  ) {
    this.street = street
    this.complement = complement
    this.number = number
    this.city = city
    this.neighborhood = neighborhood
    this.state = state
    this.country = country
    this.zipCode = zipCode
  }

  buildGoogleMapsLink() {
    return `${appSettings.apiGoogleMaps}${this.street}, ${this.number} - ${this.neighborhood}, ${this.city} - ${this.state}`
  }

  buildFormattedAddress() {
    const street = this.street ? this.street : ''
    const number = this.number ? `, ${this.number}` : ''
    const complement = this.complement ? ` - ${this.complement}` : ''
    const neighborhood = this.neighborhood ? ` - ${this.neighborhood}` : ''
    const city = this.city ? `, ${this.city}` : ''
    const state = this.state ? ` - ${this.state}` : ''
    const zipCode = this.zipCode ? `, CEP: ${getMaskZipCode(this.zipCode)}` : ''

    return `${street}${number}${complement}${neighborhood}${city}${state}${zipCode}`
  }
}
